import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { delay } from 'rxjs/operators';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
    DeliveryDefenseScoreInformationDialogComponent,
} from '../../../ship/components/delivery-defense/delivery-defense-score-information-dialog/delivery-defense-score-information-dialog.component';
import { AddressConfidenceComponent } from '../../../ship/address-confidence/address-confidence.component';

@Component({
    selector: 'upsc-confidence-gauge',
    templateUrl: './confidence-gauge.component.html',
    styleUrls: ['./confidence-gauge.component.scss'],
})
export class ConfidenceGaugeComponent implements OnInit {
    @Input() public mode: 'normal' | 'compact' = 'normal';
    @Input() public value = 0;
    @Input() public min = 100;
    @Input() public max = 1000;
    @Input() public coverageThreshold = 499;
    @Input() public averageConfidenceThreshold = 500;
    @Input() public highConfidenceThreshold = 900;
    @Input() public shouldShowScore = true;
    @Input() public shouldShowConfidenceLabels = true;
    @Input() public shouldShowMinMaxValues = false;
    @Input() public shouldShowCoverageRange = true;

    @HostBinding('class') public hostClass = 'confidence-gauge';

    public progressWidth$ = new BehaviorSubject<string>('0%');

    constructor(private readonly dialog: MatDialog) {
    }

    public get progressWidth() {
        if (this.value <= this.min) {
            return `0`;
        }

        if (this.value >= this.max) {
            return `100%`;
        }

        const percentage = (this.value - this.min) * 100 / (this.max - this.min);
        return `${ percentage }%`;
    }

    public ngOnInit() {
        /**
         * WARN: Do not set delay to 0. It will create an infinite loop:
         *  1. progressWidth$.pipe(delay(0)) subscribes immediately.
         *  2. `this.progressWidth$.next(this.progressWidth);` called in that subscription immediately emits to any subscription.
         *  3. This consequently triggers the subscription again.
         *  --> infinite loop!
         */
        this.progressWidth$.pipe(delay(10))
            .subscribe(() => {
                this.progressWidth$.next(this.progressWidth);
            });
    }

    public getRangeWidth(from: number, to: number): string {
        return `${ (to - from) * 100 / (this.max - this.min) }%`;
    }

    public getRangeStartPosition(value: number): string {
        return `${ (value - this.min) * 100 / (this.max - this.min) }%`;
    }

    public openScoreInfoDialog(event: MouseEvent) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const dialogConfig: MatDialogConfig = {
            disableClose: true,
            width: '70%',
            panelClass: 'mobile-fullscreen-dialog',
            data: {},
        };

        const dialogRef = this.dialog.open(DeliveryDefenseScoreInformationDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(() => {
        });
    }
}
